//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PaymentDetailsDisplayItem extends ItemBase {
    SchoolID: string | null = null;
    FamilyID: string | null = null;
    ParentID: string | null = null;
    PaymentProcessorID: string | null = null;
    InvoiceDetailsID: string = "00000000-0000-0000-0000-000000000000";
    PaidAmount: number = 0;

    constructor(initializer?: Partial<PaymentDetailsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PaymentDetailsDisplayItem";
}
